import React from 'react';
import './App.css';
import './Navbar.css';
import { AiOutlineLogout } from "react-icons/ai"
import { BsCardList, BsFileEarmarkArrowDown, BsPerson, BsDatabaseCheck, BsInfo  } from "react-icons/bs"
import { FaChartLine } from "react-icons/fa6"

import AppLang from './AppLang.json';

import { useNavigate } from "react-router-dom";

class Navbar extends React.Component {

	constructor(props) {

		super(props);

		this.handleClick = this.handleClick.bind(this);		
	}
	
	componentDidMount() {
	}

	componentWillUnmount() {
	};
	
	handleClick(page) {

		const navigate = this.props.navigate;

		if (page === "/logout") {
			this.props.logoutClearVariables();
			navigate("/login");
		} else {
			navigate(page);
		}

		this.props.closeNavbar();
	}
	
	render() {
		
		var appUserType = this.props.appUserType;
		var notebookUserType = this.props.notebookUserType;

		if (appUserType >= 100) {
			//showMonthlyYN = true;
		}
		
		var showMonthlyYN = false;

		var navbarOpenYN = this.props.navbarOpenYN;
		if (!navbarOpenYN) {
			return (<div></div>);
		}
		
		var showVendorAssesmentYN = false;
		var companyID = this.props.companyID;
		if (companyID === 104) {
			showVendorAssesmentYN = true;
		}

		return (
			<div id="navbar" className="Navbar">

				<div
				  role="menuitem"
				  className="NavbarLink"
				  onClick={() => this.handleClick("/notebooks")}
				>
					<div className="NavbarLinkColumn1">
						<BsCardList style={{ color: "white", width: "25px", height: "25px" }} />
					</div>
					<div className="NavbarLinkColumn2">{this.props.getLang(AppLang, "notebooks")}</div>				  					  
				</div>

				{showVendorAssesmentYN && (<div
				  role="menuitem"
				  className="NavbarLink"
				  onClick={() => this.handleClick("/vendors")}
				>
					<div className="NavbarLinkColumn1">
						<FaChartLine style={{ color: "white", width: "25px", height: "25px" }} />
					</div>
					<div className="NavbarLinkColumn2">{this.props.getLang(AppLang, "vendorAssessment")}</div>				  					  
				</div>)}

				<div
				  role="menuitem"
				  className="NavbarLink"
				  onClick={() => this.handleClick("/queue")}
				>
					<div className="NavbarLinkColumn1">
						<BsDatabaseCheck style={{ color: "white", width: "25px", height: "25px" }} />
					</div>
					<div className="NavbarLinkColumn2">{this.props.getLang(AppLang, "processingQueue")}</div>				  					  
				</div>

				<div
				  role="menuitem"
				  className="NavbarLink"
				  onClick={() => this.handleClick("/log")}
				>
					<div className="NavbarLinkColumn1">
						<BsFileEarmarkArrowDown style={{ color: "white", width: "25px", height: "25px" }} />
					</div>
					<div className="NavbarLinkColumn2">{this.props.getLang(AppLang, "llmLog")}</div>				  					  
				</div>

				<div
				  role="menuitem"
				  className="NavbarLink"
				  onClick={() => this.handleClick("/settings")}
				>
					<div className="NavbarLinkColumn1">
						<BsPerson style={{ color: "white", width: "25px", height: "25px" }} />
					</div>
					<div className="NavbarLinkColumn2">{this.props.getLang(AppLang, "settings")}</div>
				</div>

				<div
				  role="menuitem"
				  className="NavbarLink"
				  onClick={() => this.handleClick("/about")}
				>
					<div className="NavbarLinkColumn1">
						<BsInfo style={{ color: "white", width: "25px", height: "25px" }} />
					</div>
					<div className="NavbarLinkColumn2">{this.props.getLang(AppLang, "about")}</div>				  					  
				</div>

				<div
				  role="menuitem"
				  className="NavbarLink"
				  onClick={() => this.handleClick("/logout")}
				>
					<div className="NavbarLinkColumn1">
						<AiOutlineLogout style={{ color: "white", width: "25px", height: "25px" }} />
					</div>
					<div className="NavbarLinkColumn2">Logout</div>
				</div>

			</div>
		);
	}
}

export default function NavbarFunction(props) {
	const navigate = useNavigate();
	return <Navbar {...props} navigate={navigate} />;
}

